export default "__VITE_ASSET__cjWjVEo0__"